import { render, staticRenderFns } from "./apporveModal.vue?vue&type=template&id=674b548c&scoped=true&"
import script from "./apporveModal.vue?vue&type=script&lang=js&"
export * from "./apporveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674b548c",
  null
  
)

export default component.exports